import * as _ from 'lodash'

export const collectionsUnique = (products) => {
    const collectionsAll = []
    for (let i = 0; i < products.length; i++) {
        if (products[i].Coleccion !== '') {
            collectionsAll.push(products[i].Coleccion.trim())
        }
    }
    let distinct = _.uniq(collectionsAll);
    let distinctOrder = distinct.sort(function (a, b) {
        return a.localeCompare(b);
    });

    return distinctOrder
}